var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub-tab"
  }, [_c('v-container', [_vm.page == '회사소개' ? _c('ul', {
    staticClass: "tab tab--block"
  }, [_c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '1'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "/company/greeting"
    }
  }, [_c('span', [_vm._v("인사말")]), _c('span', {
    staticClass: "dot"
  })]), _c('span', {
    staticClass: "dot"
  })]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '2'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "/company/history"
    }
  }, [_c('span', [_vm._v("연혁")]), _c('span', {
    staticClass: "dot"
  })]), _c('span', {
    staticClass: "dot"
  })]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '3'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "/company/partners"
    }
  }, [_c('span', [_vm._v("파트너 거래처")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '4'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "/company/contact"
    }
  }, [_c('span', [_vm._v("오시는 길")])])])]) : _vm._e(), _vm.page == '비즈니스' ? _c('ul', {
    staticClass: "tab tab--block"
  }, [_c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '1'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "/business/overview"
    }
  }, [_c('span', [_vm._v("사업개요")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '2'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "/business/vnm"
    }
  }, [_c('span', [_vm._v("비전&미션")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '3'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "/business/process"
    }
  }, [_c('span', [_vm._v("프로세스")])])])]) : _vm._e(), _vm.page == '제품안내' ? _c('ul', {
    staticClass: "tab tab--block"
  }, [_c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '1'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "#1"
    }
  }, [_c('span', [_vm._v("각종소스류")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '2'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "#2"
    }
  }, [_c('span', [_vm._v("제과제빵류")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '3'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "#3"
    }
  }, [_c('span', [_vm._v("공산품식자재")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '3'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "#4"
    }
  }, [_c('span', [_vm._v("유제품")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '4'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "#5"
    }
  }, [_c('span', [_vm._v("면류")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '5'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "#6"
    }
  }, [_c('span', [_vm._v("냉동/냉장식품")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '6'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "#7"
    }
  }, [_c('span', [_vm._v("육가공류")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '7'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "#8"
    }
  }, [_c('span', [_vm._v("야채/신선식품")])])])]) : _vm._e(), _vm.page == '고객센터' ? _c('ul', {
    staticClass: "tab tab--block"
  }, [_c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '1'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "/service/inquiry"
    }
  }, [_c('span', [_vm._v("상담문의")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '2'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "/service/notice"
    }
  }, [_c('span', [_vm._v("공지사항")]), _c('span', {
    staticClass: "dot"
  })])]), _c('li', {
    staticClass: "tab__li",
    class: {
      active: _vm.tabActive == '3'
    }
  }, [_c('a', {
    staticClass: "tab__btn",
    attrs: {
      "href": "/service/question"
    }
  }, [_c('span', [_vm._v("자주 묻는 질문")])])])]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }